function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import qs from 'qs';
import Cookie from 'js-cookie';
export var AuthTokenService = {
  name: 'authToken',
  get: function get() {
    var token = Cookie.get(decodeURIComponent(this.name));
    return token ? JSON.parse(token) : token;
  },
  set: function set(params, domain, options) {
    Cookie.set(this.name, JSON.stringify(params), _objectSpread({
      httpOnly: false,
      domain: domain,
      expires: new Date(Number.MAX_SAFE_INTEGER / 512)
    }, options));
  },
  remove: function remove() {
    Cookie.remove(this.name);
  }
};
export var updateParamsSerializer = function updateParamsSerializer(config) {
  // eslint-disable-next-line no-param-reassign
  config.paramsSerializer = function (params) {
    return qs.stringify(params, {
      arrayFormat: 'brackets'
    });
  };

  return config;
};
export var addUserToken = function addUserToken(token, config) {
  // eslint-disable-next-line no-param-reassign
  config.headers['X-User-Id'] = token.id; // eslint-disable-next-line no-param-reassign

  config.headers['X-User-Token'] = token.token;
  return config;
};
export var getRejectedPromise = function getRejectedPromise(error) {
  return Promise.reject(error);
};
export var getResponseData = function getResponseData(response) {
  var data = response.data.data;
  return data;
};